module.exports = __webpack_public_path__ + "static/media/tripadvisor-white.7b2b7596.svg";